/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs/Observable';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { LabOrders } from '../model/models';
import { environment } from '../../environments/environment';

@Injectable()
export class GetReceiptReportService {
    protected basePath = environment.appSetting.apiUrl + 'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetPatientPortalMedicationList
     * This API get PatientPortalMedicationList
     * @param patientId patient Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public GetReceiptReport(receiptId: number,practiceHeader:string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetReceiptReport(receiptId: number,practiceHeader:string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetReceiptReport(receiptId: number,practiceHeader:string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetReceiptReport(receiptId: number,practiceHeader:string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let isMobile: any = false;
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (receiptId !== undefined && receiptId !== null) {
            queryParameters = queryParameters.set('receiptId', <any>receiptId);
        }
        //if (practiceHeader !== undefined && practiceHeader !== null) {
        //    queryParameters = queryParameters.set('practiceHeader', <any>practiceHeader);
        //}
        queryParameters = queryParameters.set('isMobile', isMobile);
        let headers = this.defaultHeaders;
        
        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        
        return this.httpClient.get<Blob>(`${this.basePath}/ReceiptReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }

    public GetReceiptReportCloud(receiptId: number, practiceHeader: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let isMobile: any = false;
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (receiptId !== undefined && receiptId !== null) {
            queryParameters = queryParameters.set('receiptId', <any>receiptId);
        }
        //if (practiceHeader !== undefined && practiceHeader !== null) {
        //    queryParameters = queryParameters.set('practiceHeader', <any>practiceHeader);
        //}
        queryParameters = queryParameters.set('isMobile', isMobile);
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/ReceiptReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
